module.exports = __webpack_public_path__ + "img/bigwin-text.60eafc11.png";